import type { TBookmark } from './api';

/** "Stripe production · default"; "—" when no flow tests with it. */
export const testSampleLine = (bookmark: TBookmark): string =>
  bookmark.testSampleIn.length === 0
    ? '—'
    : `${bookmark.testSampleIn.map((flow) => flow.flowName).join(', ')} · default`;

export const isDefaultIn = (bookmark: TBookmark, flowId: string): boolean =>
  bookmark.testSampleIn.some((flow) => flow.flowId === flowId);

/** A bookmark with no source left can still be opened, but no flow can test with it. */
export const isUsableSample = (bookmark: TBookmark): boolean =>
  bookmark.notUsableReason == null && bookmark.sourceId !== null;
